// Rodzaj produktu grupowego / produktu. Wartosci zgodne z enum `kind` w API PIM.
// Produkt dziedziczy rodzaj z produktu grupowego; rodzaj jest niezmienny po utworzeniu.
// `shipment` = przesylka kurierska (produkt reprezentujacy koszt dostawy w zamowieniu).
const product_kind_options = [
  { label: "Towar", value: "goods" },
  { label: "Usługa", value: "service" },
  { label: "Przesyłka", value: "shipment" },
];

export const default_product_kind = "goods";

export const getKindLabel = (val) =>
  product_kind_options.find(({ value }) => value === val)?.label || val;

export default product_kind_options;
